import { HomeIcon } from './svg/HomeIcon'
import { ChartIcon } from './svg/ChartIcon'
import { LiveIcon } from './svg/LiveIcon'
import { SideButton } from './SideButton'

export default function SideBar() {

  return (
    <div
      className="bg-white mt-0 border-solid border-t-0 border-l-0 border-r-0 border-b-0
    border-tdpldarkgrey border-opacity-50 h-100vh min-w-fit max-w-fit pl-[1rem] pr-[0.5rem]"
    >
      <SideButton to="/" titleKey="menu.home" testId="nav-home">
        <HomeIcon />
      </SideButton>
      <SideButton to="/chart" titleKey="menu.chart" testId="nav-chart">
        <ChartIcon />
      </SideButton>
      <SideButton to="/live" titleKey="menu.live" testId="nav-live" disabled>
        <LiveIcon />
      </SideButton>
    </div>
  )
}
